import React from 'react';
import possibilityImage from '../../assets/possibility.png';
import './possibility.css';

const Possibility = () => (
  <div className="gpt3__possibility section__padding" id="possibility">
    <div className="gpt3__possibility-image">
      <img src={possibilityImage} alt="possibility" />
    </div>
    <div className="gpt3__possibility-content">
      <h4>Request Early Access to Get Started</h4>
      <h1 className="gradient__text">The only limit is your imagination</h1>
      <p>GPT-3 chatbots are programmable artificial intelligence applications built on development work by OpenAPI and powered by the GPT-3 language model. Also known as “Generative Pretrained Transformer 3,” the trained language processing software that powers these bots includes more than 175 billion machine learning parameters. The parameters help the GPT-3 bot analyze a communication input and generate an appropriate response. </p>
      <h4>Request Early Access to Get Started</h4>
    </div>
  </div>
);

export default Possibility;